/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Titulo de las recomendaciones del carrito.
(function () {
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      document.querySelectorAll('.cart-recommendations__title-text').forEach(function (el) {
        if (el.textContent.trim() !== 'Anillos que cuentan historias') el.textContent = 'Anillos que cuentan historias';
      });
    }, 60);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();

// Enlace "Conoce tu talla" dentro de la vista rapida de producto.
(function () {
  var style = document.createElement('style');
  style.textContent = '.lclz-size-link{display:inline-flex;align-items:center;gap:8px;margin:2px 0 16px;font-size:0.85rem;letter-spacing:0.04em;color:inherit;text-decoration:underline;text-underline-offset:3px}';
  document.head.appendChild(style);

  var pending = false;
  function addLinks() {
    document.querySelectorAll('.quick-shop__main .product-form__variant').forEach(function (variant) {
      if (variant.parentElement.querySelector('.lclz-size-link')) return;
      var link = document.createElement('a');
      link.className = 'lclz-size-link';
      link.href = '/pages/conoce-tu-talla';
      link.target = '_blank';
      link.rel = 'noopener';
      link.innerHTML = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="2" y="8" width="20" height="8" rx="1"/><path d="M6 8v3M10 8v4M14 8v3M18 8v4"/></svg><span>Conoce tu talla</span>';
      variant.insertAdjacentElement('afterend', link);
    });
  }

  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; addLinks(); }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
  addLinks();
})();

// Barra de envio gratis del carrito: oculta (el envio gratis por cantidad era parte del Cyber).
(function () {
  var style = document.createElement('style');
  style.textContent = 'free-shipping-bar,.free-shipping-bar{display:none!important}';
  document.head.appendChild(style);
})();
